import type { Router } from 'vue-router';

/**
 * Opens the "Phiếu nhập kho" PDF viewer page in a new browser tab.
 */
export function openPhieuNhapKhoPdf(
  router: Router,
  idPhieuNhapKho: number | string | null | undefined
): void {
  if (!idPhieuNhapKho) return;

  const route = router.resolve({
    name: 'xem-phieu-nhap-kho',
    params: { id: String(idPhieuNhapKho) },
  });

  window.open(route.href, '_blank');
}
